
































































































































































































































































































import { mixins } from "vue-class-component";
import { Component, Vue } from "vue-property-decorator";
import {
  NavBar,
  Image,
  Tabbar,
  TabbarItem,
  Search,
  Field,
  Picker,
  Popup,
  Button,
  Toast,
  List,
  Cell,
  CellGroup,
  Dialog,
  Tag,
  Icon,
  Row,
  Col,
  NoticeBar,
  Loading,
  Card,
} from "vant";
import WeMixin from "@/components/weMixin";
import api from "../../../components/http/api";
import { RegisterInfo } from "../user/UserApi";
import { CouponRequestInfo, YhfflInfo } from "./YhfflApi";
import moment from "moment";

declare const $: any;

@Component({
  components: {
    [NavBar.name]: NavBar,
    [Image.name]: Image,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Card.name]: Card,
    [Search.name]: Search,
    [Field.name]: Field,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [List.name]: List,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [Tag.name]: Tag,
    [Icon.name]: Icon,
    [Row.name]: Row,
    [Col.name]: Col,
    [NoticeBar.name]: NoticeBar,
    [Loading.name]: Loading,
  },
})
export default class YhfflHome extends mixins(WeMixin) {
  private isError: boolean = true;
  private isShowError: boolean = false;
  private buttonShow: boolean = false;
  private buttonActive: boolean = true;
  private showbg: boolean = true;

  private errmsg: string = "";
  private errDialog: boolean = false;
  private errDialogFalse: boolean = false;

  private registerInfo: RegisterInfo = {} as RegisterInfo;
  private couponRequestInfo: CouponRequestInfo = {} as CouponRequestInfo;
  private yhfflInfo: YhfflInfo = {} as YhfflInfo;
  private rTime: number = 0;

  protected created() {
    this.checkIsSubscribe();
  }

  protected toRegister() {
    this.$router.replace(
      "/main/user/registerFromCouponAll/" + this.$route.params.activityid
    );
  }

  protected toRaffle() {
    this.$router.go(0);
  }

  protected checkIsSubscribe() {
    api.post("/weixinmp/xsyx/myuser/checkIsSubscribe", {}).then((res: any) => {
      if (!res.data) {
        this.isError = false;
        this.isShowError = true;
      } else {
        this.getCustomerInfo();
      }
    });
  }

  protected getCustomerInfo() {
    api.get("/weixinmp/xsyx/myuser/getCustomerInfo").then((res: any) => {
      if (res.data.flag === "0") {
        this.registerInfo = res.data;
        this.buttonShow = true;
        this.checkDate();
      } else if (res.data.flag === "1") {
        const interval = window.setInterval(() => {
          if (--this.rTime <= 0) {
            window.clearInterval(interval);
            this.$router.replace(
              "/main/user/registerFromCouponAll/" +
                this.$route.params.activityid
            );
          }
        }, 2000);
      }
    });
  }

  protected checkDate() {
    const todayDay = moment().format("HH");
    if (todayDay < "09" && todayDay > "20") {
      this.errDialogFalse = true;
      this.errmsg = "请于每日9:00-20:00期间抽奖！";
      this.buttonShow = false;
    } else {
      this.getYhfflBaseInfo();
    }
  }

  protected getYhfflBaseInfo() {
    this.couponRequestInfo.openid = this.registerInfo.openid;
    this.couponRequestInfo.phone = this.registerInfo.phone;
    this.couponRequestInfo.orgid = this.registerInfo.orgid;
    this.couponRequestInfo.activityid = this.$route.params.activityid;
    api
      .post("/weixinmp/xsyx/yhffl/getYhfflBaseInfo", this.couponRequestInfo)
      .then((res: any) => {
        if (res.data.showinfo) {
          this.yhfflInfo = res.data;
          if (this.yhfflInfo.realnum < 0 || this.yhfflInfo.realnum > 11) {
            this.errDialogFalse = true;
            this.errmsg = "抽奖次数异常！";
            this.buttonShow = false;
            this.showbg = false;
          }
        } else {
          this.errDialogFalse = true;
          this.errmsg = "未查询到相关信息！";
          this.buttonShow = false;
          this.showbg = false;
        }
      });
  }

  protected getCouponFromNotify() {
    const todayDay = moment().format("HH");
    if (todayDay < "09" && todayDay > "20") {
      this.$toast({
        message: "请于每日9:00-20:00期间抽奖！",
        position: "bottom",
      });
    } else {
      this.couponRequestInfo.openid = this.registerInfo.openid;
      this.couponRequestInfo.phone = this.registerInfo.phone;
      this.couponRequestInfo.orgid = this.registerInfo.orgid;
      this.couponRequestInfo.activityid = this.$route.params.activityid;
      this.buttonActive = false;
      if (this.yhfflInfo.realnum > 0) {
        // 498供应商
        window.location.href =
          process.env.VUE_APP_498_URL +
          encodeURIComponent(
            // "https://www.tongdatech.com:443/xsyx" +
            process.env.VUE_APP_URLFRONT +
              "/main/coupon/getCouponFromNotifyResult498?a=" +
              this.couponRequestInfo.orgid +
              "&b=" +
              this.couponRequestInfo.phone +
              "&c=" +
              this.couponRequestInfo.activityid +
              "&d=" +
              this.couponRequestInfo.openid
          );
      } else {
        this.$toast("无剩余抽奖次数");
      }
    }
  }

  protected toYhfflToNavigation() {
    this.$router.push("/main/yhffl/yhfflToNavigation");
  }

  protected toYhfflToPbQRcode() {
    this.$router.push("/main/yhffl/yhfflToPbQRcode");
  }

  protected toYhfflToYMT() {
    this.$router.push("/main/yhffl/yhfflToYMT");
  }

  protected toYhfflToChoose() {
    this.$router.push("/main/yhffl/yhfflToChoose");
  }
}
